import { EnergyLabelsResponse } from "@/components/EnergySaving/data/EnergyLabelsFetcher.ts";
import { getEnergyLabelResult } from "@/components/EnergySaving/utils.ts";
import { Variant } from "@/types/types.ts";
import ProductCard from "@JohnLewisPartnership/jl-design-system/dist/components/product-card/ProductCard";
import type { ReactNode } from "react";
import styles from "./CheaperAlternatives.module.scss";

type Props = {
  updateResponse: EnergyLabelsResponse;
  variant: Variant;
};
const CheaperAlternatives = ({ updateResponse, variant }: Props) => {
  const result = getEnergyLabelResult(updateResponse, variant);

  if (!result) return null;

  const { alternativeProducts } = result;

  const renderAlternativeProducts = (): ReactNode[] =>
    alternativeProducts.map((altProd, index) => {
      const {
        sku,
        manufacturer,
        price,
        compareBuy,
        compareRun,
        compareSaving,
        imageUrl,
        url,
      } = altProd;

      const productCardData = {
        id: sku,
        title: manufacturer,
        image: imageUrl,
        price: {
          now: price,
        },
        brand: manufacturer,
        url,
      };

      return (
        <div className={styles.alternatives__card} key={index}>
          <ProductCard
            buttonSettings={{
              hasAddToBasketButton: false,
              hasQuickViewButton: false,
              hasEmailMeWhenAvailableButton: false,
              hasMoreInformationButton: false,
            }}
            product={productCardData}
          >
            <div>{sku}</div>
            <div>{compareBuy} more to buy</div>
            <div>{compareRun} less to run</div>
            <div>{compareSaving} saving</div>
          </ProductCard>
        </div>
      );
    });

  const getTitle = () => {
    const numProducts = alternativeProducts.length;
    if (!numProducts) {
      return "There are no products in this price range that are cheaper to run.";
    }

    const isSingular = alternativeProducts.length === 1;
    return `We've found ${numProducts} other ${isSingular ? "product" : "products"}
            that ${isSingular ? "is" : "are"} cheaper to run`;
  };

  return (
    <div className={styles.alternatives}>
      <h2>{getTitle()}</h2>
      <div className={styles.alternatives__products}>
        {renderAlternativeProducts()}
      </div>
    </div>
  );
};

export default CheaperAlternatives;
